import React, { useEffect, useState, useContext } from "react";
import { Table, Form } from "react-bootstrap";
import getInvestments from "../../MongoDb/GetInvestments";
import { useTheme } from '../ThemeContext';
import './InvestmentsNew.css';
import KPITiles from "../KPITile";
import { Users } from 'react-feather';
import { Link } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import '../shared/PageHeader.css';

export default function InvestmentsNew() {
  const { isDarkMode } = useTheme();
  const [investments, setInvestments] = useState();
  const [sortColumn, setSortColumn] = useState('Portfolio Value');
  const [sortDirection, setSortDirection] = useState("desc");
  const { user, userProfile } = useContext(AuthContext);

  // Fetch investments
  useEffect(() => {
    const fetchInvestments = async () => {
      try {
        const investments = await getInvestments();
        setInvestments(JSON.parse(investments));
      } catch (error) {
        console.error('Failed to get investments:', error);
      }
    };
    fetchInvestments();
  }, []);

  // Update fund_nav if user's name matches a name in the table
  useEffect(() => {
    const updateFundNav = async () => {
      if (!user || !investments || !userProfile) return;
      const userName = userProfile.name || "";

      const match = investments.find(
        (item) => item.Investor && item.Investor.toLowerCase() === userName.toLowerCase()
      );

      if (match && match["Portfolio Value"] !== undefined) {
        const portfolioValue = parseFloat(match["Portfolio Value"]);
        try {
          // TODO: Implement API endpoint to update fund_nav
          // const response = await fetch(`http://localhost:5000/api/user/${user.id}/balance`, {
          //   method: 'PUT',
          //   headers: { 'Content-Type': 'application/json' },
          //   body: JSON.stringify({ fund_nav: portfolioValue })
          // });
          console.log("updateFundNav called successfully");
        } catch (err) {
          console.error("Failed to update fund_nav:", err);
        }
      } else {
        console.log("No matching row or Portfolio Value undefined");
      }
    };
    updateFundNav();
  }, [user, investments, userProfile]);

  let numInvestor = 0;
  let totalInvestment = 0;
  let totalProfit = 0;
  let investmentsHead = null;
  let investmentsRows = null;

  const handleHeaderClick = (columnName) => {
    if (sortColumn === columnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(columnName);
      setSortDirection("desc");
    }
  };

  if (investments != undefined) {
    const keys = Object.keys(investments[0]);
    const cleanUpAndSortInvestments = (investments) => {
      return investments.sort((a, b) => {
        if (sortColumn) {
          const aValue = a[sortColumn];
          const bValue = b[sortColumn];
          const isNumeric = (value) => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(value);
          const isPercentage = (value) => /%$/.test(value);

          if (isNumeric(aValue) && isNumeric(bValue)) {
            const aNumber = parseFloat(aValue.replace(/[$,%]/g, ""));
            const bNumber = parseFloat(bValue.replace(/[$,%]/g, ""));
            if (sortDirection === "asc") {
              return aNumber - bNumber;
            } else {
              return bNumber - aNumber;
            }
          } else if (isPercentage(aValue) && isPercentage(bValue)) {
            const aNumber = parseFloat(aValue.replace(/[$,%]/g, "").replace(",", ""));
            const bNumber = parseFloat(bValue.replace(/[$,%]/g, "").replace(",", ""));
            if (sortDirection === "asc") {
              return aNumber - bNumber;
            } else {
              return bNumber - aNumber;
            }
          } else {
            if (sortDirection === "asc") {
              return aValue.localeCompare(bValue, undefined, { sensitivity: 'base' });
            } else {
              return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
            }
          }
        }
        return 0;
      });
    };

    const sortedInvestments = cleanUpAndSortInvestments(investments);

    const renderSortingIndicator = (columnName) => {
      if (columnName === sortColumn) {
        if (sortDirection === "asc") {
          return <span className="sort-indicator">&#9650;</span>;
        } else {
          return <span className="sort-indicator">&#9660;</span>;
        }
      }
      return null;
    };

    investmentsHead = keys.map(key => (
      <th
        key={key}
        onClick={() => handleHeaderClick(key)}
        className={`investor-table-header ${key === sortColumn ? "sortable active" : "sortable"}`}
      >
        {key} {renderSortingIndicator(key)}
      </th>
    ));

    investments.forEach((item) => {
      numInvestor += 1
      totalInvestment += parseFloat(item['Total Investment']);
      totalProfit += parseFloat(item['Total Profit']);
    });

    investmentsRows = sortedInvestments.map((item, index) => {
      const columns = keys.map(key => {
        let value = item[key];
        if (key === "Fund % Start of Day" || key === "% Return") {
          value = Number(value).toFixed(2);
          value = `${value}%`;
          if (value === "-100.00%" || parseFloat(value) === -100) {
            value = "WTHD";
          }
        }
        if (key === "Total Investment" || key === "Total Profit" || key === "Portfolio Value") {
          const numberFormat = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
          });
          value = numberFormat.format(value);
        }
        return <td key={key} className="investorRow investor-table-cell">{value}</td>;
      });
      return <tr key={index}>{columns}</tr>;
    });
  }

  const investorKPIs = [
    {
      'label' : 'Investment',
      'value' : totalInvestment,
      'accent' : ((totalProfit + totalInvestment) - totalInvestment) / totalInvestment,
      'value_format' : 'Dollar',
      'accent_format' : 'Percent',
    },
    {
      'label' : 'Investors',
      'value' : numInvestor,
      'accent' : '',
      'value_format' : 'Text',
      'accent_format' : 'Text',
    }
  ]

  return (
  <>
    {/* bets Header */}
    <div className="top-header-header">
      <div className="top-header-title">
        <Users className="top-header-icon" />
        <div>
          <h1>Investors</h1>
        </div>
      </div>
      <p className="top-header-subtitle">
        View investor performance, track fund NAV, and performance.
      </p>
    </div>
    <div style={{ paddingBottom: '100px' }}>
      <div className="bets-page">
        {typeof investorKPIs === 'undefined' || Object.keys(investorKPIs).length === 0 || investorKPIs === 'Failed to get bets'? (
          <div>KPIs Loading</div>
        ) : (
          <KPITiles kpis={investorKPIs} title={'Fund'} />
        )}
      </div>
      <h3 className="col-header">All Investors</h3>
      <div className="table-container">
        <Table responsive striped bordered size="sm" variant="dark" className="investments-table" style={{ marginBottom: '0' }}>
          <thead className="investorHeader">
            {investmentsRows ? <tr>{investmentsHead}</tr> : null}
          </thead>
          <tbody>
            {investmentsRows == undefined ? <div> Investments Loading </div> : investmentsRows}
          </tbody>
        </Table>
      </div>
    </div >
    </>
  );
}